import './App.css';
import React from "react"
import {Routes, Route} from "react-router-dom";
import HomeWrapper from "./pages/home/HomeWrapper";
import Layout from "./shared/components/Layout";
import PageWrapper from "./shared/components/PageWrapper";
import AboutUsWrapper from "./pages/aboutus/AboutUsWrapper";

function App() {
  return (
    <Layout>
      <PageWrapper>
        <Routes>
          <Route exact path="/" element={<HomeWrapper />} />
          <Route path="/aboutus" element={<AboutUsWrapper/>} />
        </Routes>
      </PageWrapper>
    </Layout>
  );
}

export default App;
